import { forwardRef, type Ref, type SVGProps } from "react";
const IconBedroomOutlineSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="M28 14V5a1 1 0 0 0-2 0v2H6V5a1 1 0 0 0-2 0v9a2 2 0 0 0-2 2v11a1 1 0 0 0 2 0v-4h24v4a1 1 0 0 0 2 0V16a2 2 0 0 0-2-2M17 9h9v5h-9zM6 9h9v5H6zm22 12H4v-5h24z" /></svg>;
const ForwardRef = forwardRef(IconBedroomOutlineSVG);
ForwardRef.displayName = "IconBedroomOutline";
export { ForwardRef as IconBedroomOutline };